import { QueryKeys } from "@/constants";
import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import type { IUserInfo } from "./use-user-info";
import { myBenefits } from "@/services/my-benefits-service";
import type { MyBenefits } from "@/model/my-benefits";
import type { PlanCoverageInfo } from "@/model/demographics";

export const useMyBenefits = (
  userInfo: IUserInfo,
  activeCoverage: PlanCoverageInfo,
): UseQueryResult<MyBenefits, Error> => {
  return useQuery<MyBenefits, Error>({
    queryKey: [
      QueryKeys.MY_BENEFITS,
      userInfo.memberId,
      activeCoverage.claimCoverageCode,
    ],
    queryFn: () => myBenefits(userInfo, activeCoverage),
    enabled: Boolean(userInfo?.accessToken) && Boolean(userInfo?.memberId),
  });
};
